import { createAsyncThunk, createSlice, isAsyncThunkAction,PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import fetchAPI from '../../../common/fetchAPI'
import { ShiftStateClass } from "./interfaces/ShiftStateClass";
import { removePropertyFromArray } from '../../../common/timeLiveFunction';
import { sortData } from "../../../common/timeLiveFunction";
import fetchTimeliveAPI from "../../../common/fetchTimeliveAPI";

const initialState: ShiftStateClass = {
    isLoading: false,
    shiftList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'Name',
    search: '',
    pageNo: 1,
    pageSize: 10
};

interface IThunkApi {
    state: {
        shift: ShiftStateClass
    }
};

export const getAccountShiftsAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "Shift/v2/getAccountShifts",
        async (arg, thunkApi) => {
            // const response = await fetchAPI('api/v2/Shifts', 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchTimeliveAPI('api/Shift/GetAccountShift', 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const getAccountShiftByAccountShiftIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Shift/v2/getAccountShiftByAccountShiftId",
        async (arg, thunkApi) => {
            // const response = await fetchAPI('api/v2/Shifts/' + arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchTimeliveAPI('api/Shift/GetAccountShiftById/' + arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const addAccountShiftAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Shift/v2/addAccountShift',
        async (arg, thunkApi) => {
            const { AccountShift, AccountBreaks, ...argWithoutId } = arg;
            let AccountBreaksNew = removePropertyFromArray(AccountBreaks, 'BreakTime');
            AccountBreaksNew = AccountBreaksNew.map((breakItem: any) => {
                return {
                    ...breakItem,
                    BreakDuration: typeof breakItem.BreakDuration === 'number'
                        ? breakItem.BreakDuration
                        : parseInt(breakItem.BreakDuration) || 0
                };
            });
            const AccountShiftWithBreaks = {
                AccountShift: AccountShift,
                AccountBreaks: AccountBreaksNew
            };
            // const response = await fetchAPI('api/v2/Shifts/WithBreaks', 'POST', AccountShiftWithBreaks, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchTimeliveAPI('api/Shift', 'POST', AccountShiftWithBreaks, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountShiftAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Shift/v2/updateAccountShift',
        async (arg, thunkApi) => {
            const { AccountShift, AccountBreaks } = arg;
            const { AccountShiftId, ...argWithoutId } = AccountShift;
            let AccountBreaksNew = removePropertyFromArray(AccountBreaks, 'BreakTime');
            AccountBreaksNew = AccountBreaksNew.map((breakItem: any) => {
                return {
                    ...breakItem,
                    BreakDuration: typeof breakItem.BreakDuration === 'number'
                        ? breakItem.BreakDuration
                        : parseInt(breakItem.BreakDuration) || 0
                };
            });
            const AccountShiftWithBreaks = { AccountShift: argWithoutId, AccountBreaks: AccountBreaksNew }
            // const response = await fetchAPI('api/v2/Shifts/WithBreaks/' + AccountShiftId, 'PUT', AccountShiftWithBreaks, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchTimeliveAPI('api/Shift/UpdateAccountShiftWithBreak/' + AccountShiftId, 'PUT', AccountShiftWithBreaks, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const UpdateIsDisabledRecordAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Shift/v2/UpdateIsDisabledRecord',
        async (arg, thunkApi) => {
            const { AccountShiftId, IsDisabled, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/Shifts/UpdateIsDisabled/' + AccountShiftId + '/' + IsDisabled, 'PUT', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountShiftAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Shift/v2/deleteAccountShift",
        async (arg, thunkApi) => {
            // const response = await fetchAPI('api/v2/Shifts/' + arg, 'Delete', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchTimeliveAPI('api/Shift/DeleteAccountShiftWithBreak/' + arg, 'Delete', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const deleteAccountBreaksAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Breaks/v2/deleteAccountBreaks",
        async (arg, thunkApi) => {
            // const response = await fetchAPI('api/v2/Breaks/' + arg, 'Delete', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchTimeliveAPI('api/Shift/DeleteAccountBreakAsync/' + arg, 'Delete', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const DeleteSelectedAccountShiftAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Shift/v2/DeleteSelectedAccountShift",
        async (arg, thunkApi) => {
            // const response = await fetchAPI('api/v2/Shifts/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchTimeliveAPI('api/Shift/DeleteBulkAccountShiftWithBreak', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

export const shiftSlice = createSlice({
    name: 'shift',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.shiftList.findIndex((item) => item.AccountShiftId == action.payload);
            const newArray = [...state.shiftList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.shiftList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.shiftList.findIndex((item) => item.AccountShiftId == action.payload);
            const newArray = [...state.shiftList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.shiftList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.shiftList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.shiftList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.shiftList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.shiftList = newArray;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.shiftList;
            state.shiftList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(getAccountShiftsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountShiftsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.shiftList = [];
                } else {
                    state.shiftList = payload.Data;
                    state.shiftList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountShiftsAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getAccountShiftByAccountShiftIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountShiftByAccountShiftIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.selectedRecord = payload.Data;
                state.isLoading = false;
            })
            .addCase(getAccountShiftByAccountShiftIdAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(addAccountShiftAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountShiftAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addAccountShiftAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updateAccountShiftAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountShiftAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountShiftAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(UpdateIsDisabledRecordAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(UpdateIsDisabledRecordAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(UpdateIsDisabledRecordAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteAccountShiftAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountShiftAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountShiftAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteAccountBreaksAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountBreaksAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = false;
                state.isLoading = false;
            })
            .addCase(deleteAccountBreaksAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(DeleteSelectedAccountShiftAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(DeleteSelectedAccountShiftAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(DeleteSelectedAccountShiftAsync.rejected, (state) => {
                state.status = 'failed';
            })
    }

});

export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updatePagination,updateSorting } = shiftSlice.actions
export const shiftState = (state: RootState) => state.shift
export default shiftSlice.reducer
